<template>
  <div class="enginio-landing-base">
    <div class="enginio-landing-background">
      <div class="enginio-landing">
        <h2>Welcome to the platform for Brand Activation Services</h2>
      </div>

      <div class="enginio-landing-wrapper">
        <div class="enginio-landing-header consumer-header">
          <h3>Consumer searching for brands activation?</h3>
          <LanguagePicker btn-pos="inline" class="second-block"/>
        </div>
        <div class="enginio-landing-header business-header">
          <h3>Business looking to create activations</h3>
          <a class="btn btn-whitebg second-block" href="https://business.enginio.io/" target="_blank">
            Learn More
          </a>
        </div>
        <div class="enginio-landing-header eft-header">
          <h3>Enginio Financial Technology</h3>
          <a class="btn btn-whitebg btn-disabled second-block" href="https://business.enginio.io/eft" target="_blank" disabled>
            Coming soon
          </a>
        </div>
      </div>
    </div>

    <div class="enginio-landing-more-content">
      <h2>Latest news and Insights</h2>
      <h4>Stay informed and up-to-date with our latest updates.</h4>

      <!--Linkedin feed-->
      <div class="enginio-landing-linkedin-feed">
        <div
          v-for="feed in feeds"
          :key="feed.title"
          class="feed-item">
          <a :href="feed.href" target="_blank" class="feed-link">
            <img class="feed-image" :src="feed.img" alt="">
            <div class="feed-title">{{ feed.title }}</div>
            <p class="feed-tag" v-if="feed.tag">{{ feed.tag }}</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguagePickerDataMixin from '../stories/components/LanguagePicker/LanguagePickerDataMixin.vue';
import LanguagePicker from '../stories/components/LanguagePicker/LanguagePicker.vue';

export default {
  name: 'EnginioLanding',
  components: {
    LanguagePicker,
  },
  mixins: [LanguagePickerDataMixin],
  data() {
    return {
      loadedPage: false,
      bounce: false,
      countries: [],
      pickedCountry: {},
      feeds: [
        {
          img: 'https://business.enginio.io/wp-content/uploads/2025/05/Enginio-Insights-May-2025-3-400x284.png',
          title: 'How Activations can give power back to a Brand: Reclaiming control in an era of reseller dominance',
          tag: 'Monthly Market Insights',
          href: 'https://business.enginio.io/project/how-activations-can-give-power-back-to-a-brand-reclaiming-control-in-an-era-of-reseller-dominance/',
        },
        {
          img: 'https://business.enginio.io/wp-content/uploads/2025/05/topimage_article-400x284.png',
          title: 'Top tips for a Successful Activation Campaign - Insights from our Customer Success & Retention Manager, Emma Victorin',
          tag: 'News',
          href: 'https://business.enginio.io/project/top-tips-for-a-successful-activation/',
        },
        {
          img: 'https://business.enginio.io/wp-content/uploads/2025/03/MarsInsights_square-1-400x284.png',
          title: 'Navigating Retail Trends for Future Success',
          tag: 'Monthly Market Insights',
          href: 'https://business.enginio.io/project/enginio-insights-mars-2025/',
        },
        {
          img: 'https://business.enginio.io/wp-content/uploads/2024/12/Monthly2.png',
          title: 'The Importance of Real-Time Data, Dashboards, Instant Feedback in Activations',
          tag: 'Monthly Market Insights',
          href: 'https://business.enginio.io/project/the-importance-of-real-time-data-dashboards-and-instant-feedback-in-activations/',
        },
        {
          img: 'https://business.enginio.io/wp-content/uploads/2024/11/BazaarEnginio.png',
          title: 'Enginio partners with Bazaarvoice to enhance the consumer journey through Ratings & Reviews Integration',
          tag: 'News',
          href: 'https://business.enginio.io/project/enginio-partners-with-bazaarvoice-to-enhance-the-consumer-journey-through-ratings-reviews-integration/',
        },
        {
          img: 'https://business.enginio.io/wp-content/uploads/2024/11/NewsHeader-1.png',
          title: 'Capitalizing on Europe\'s Ecomomic Resurgence',
          tag: 'Monthly Market Insights',
          href: 'https://business.enginio.io/project/capitalizing-on-europes-economic-resurgence/',
        },
        {
          img: 'https://business.enginio.io/wp-content/uploads/2024/10/MarketInsightNov2024.png',
          title: 'Enginio Firsty in the World to Offer Cashback with Swedish Payment Solution Swish',
          tag: 'News',
          href: 'https://business.enginio.io/project/enginio-first-in-world-to-offer-cash-back-with-swedish-payment-solution-swish/',
        },
        /*{
          // linkedin: '7334152347264212994',
          img: '',
          title: 'Direct payouts. Anywhere.',
        },
        {
          img: '',
          title: 'Supercharge your campaigns',
        },
        {
          img: '',
          title: '👊 Brands, it\'s time to grab your mic back',
          tag: 'Coming soon',
        },*/
      ],
    };
  },
};
</script>

<style lang="scss">
.enginio-landing-base {
  .language-picker-container {
    background: transparent !important;
    padding: 0 !important;
  }

  .autocomplete {
    .autocomplete-country-selector {
      height: 42px;
      background: white;
      padding: 4px 10px;
      border-radius: 8px 0 0 8px;
      border: none;
      border-right: 1px solid #dddddd;
    }
  }
  .btn-whitebg {
    margin: 0 auto;
    font-size: 16px;
    line-height: 26px;
    border-radius: 8px;
  }
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../assets/scss/pages/EnginioLanding"
</style>
